import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import I18n from 'i18n-js';
import { deliverySelector } from 'selectors/new-booking-selectors';
import MSDDeliveryGuarantee from 'components/v2/insurance/msd-delivery-guarantee';
import useInsuranceHook from 'components/v2/insurance/hook';
import styles from 'components/v2/insurance/delivery-guarantee.less';
import OverlayBody from '../overlay-body';

const MsdDeliveryGuaranteePanel = ({ onClose, delivery }) => {
  const onConfirm = useCallback(
    () => {
      onClose();
    },
    [onClose],
  );

  const onBack = useCallback(
    () => {
      onClose();
    },
    [onClose],
  );

  const { onChange, onResetAll, deliveriesInsuranceDetails } = useInsuranceHook(
    [delivery.id],
    [delivery],
  );
  const {
    totalDisplayPrice,
    totalNonIncludedSelected,
  } = deliveriesInsuranceDetails;

  return (
    <OverlayBody
      showConfirm
      onConfirmClick={onConfirm}
      showHeader
      showTitle
      title={I18n.t('v2.anytimeBooking.insurance.editDeliveryGuarantee')}
      showClose
      showFooter
      footer={
        totalDisplayPrice && (
          <div className={styles.totalDeliveryGuarantee}>
            <span>
              {I18n.t('v2.anytimeBooking.insurance.totalDeliveryGuarantee')}
            </span>
            <span className={styles.totalPrice}>{totalDisplayPrice} </span>
          </div>
        )
      }
      onClose={onBack}
      showSecondaryCTA={totalNonIncludedSelected > 0}
      onSecondaryCTA={onResetAll}
      secondaryCTAText={I18n.t('v2.anytimeBooking.insurance.removeForAll')}
    >
      <MSDDeliveryGuarantee
        onChange={onChange}
        delivery={delivery}
        deliveriesInsuranceDetails={deliveriesInsuranceDetails}
      />
    </OverlayBody>
  );
};

MsdDeliveryGuaranteePanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  delivery: NewBookingDeliveryPropType.isRequired,
};

export default connect((state, props) => ({
  delivery: deliverySelector(state, props),
}))(MsdDeliveryGuaranteePanel);
